import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../api/axios";
import OverviewRegister from "./OverviewRegister";

const OverviewRegisterEdit = ({ is_superuser }) => {
  const { id: projectId } = useParams();

  // '모름' 상태(undefined)와 로딩 분리
  const [overview, setOverview] = useState(undefined); // undefined = 아직 모름
  const [loading, setLoading] = useState(true);
  const [canManageOverview, setCanManageOverview] = useState(false);

  const token = localStorage.getItem("access");

  useEffect(() => {
    let mounted = true;

    // 프로젝트/토큰이 없으면 즉시 종료
    if (!projectId || !token) {
      setOverview(null);
      setLoading(false);
      return;
    }

    (async () => {
      try {
        const res = await api.get(`project/${projectId}/overview/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!mounted) return;
        // 래핑된 overview 내부만 폼에 사용
        setOverview(res.data?.overview || null);
        setCanManageOverview(Boolean(res.data?.can_manage_overview));
      } catch (e) {
        if (!mounted) return;
        setOverview(null);
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [projectId, token]);

  if (loading) {
    return <div className="p-6 text-slate-500">로딩 중...</div>;
  }

  // 로딩이 끝나면 편집 폼 렌더(overview가 null이면 빈 폼으로 열림)
  return (
    <OverviewRegister
      is_superuser={is_superuser}
      canManageOverview={canManageOverview}
      initialForm={overview}
      readonly={false}
    />
  );
};

export default OverviewRegisterEdit;
